import PropTypes from 'prop-types';
import React, { Suspense, useEffect } from 'react';
import { connect } from 'react-redux';

import ThemeWrapper from '../ThemeWrapper';

import { Spinner } from 'jpi-cloud-web-ui-kit';
import { getDeviceFeatures, getSPSubscriptionStatus } from '../FeaturesFlags/actions';
import { useAppInitializer } from './useAppInitializer';

import {
  getActiveProAccountsIds,
  getAllBrands,
  getAllLanguages,
  getCloudStatus,
  getCountries,
  getLatestAgreementsVersions,
  getProAccount,
  getSupportedLanguages,
  getUserInfo,
  initApp,
  selectSystem,
  setUserDataState,
} from './actions';

export function AppInitializer({ children, userDataState, userLoggedIn, initApp, selectedLanguage, ...props }) {
  const { appLoading } = useAppInitializer({ userDataState, userLoggedIn, initApp, ...props });

  // Re-initialize when user logs in
  useEffect(() => {
    if (userLoggedIn) {
      initApp();
    }
  }, [userLoggedIn]);

  useEffect(() => {
    if (selectedLanguage) {
      document.documentElement.lang = selectedLanguage;
    }
  }, [selectedLanguage]);

  return (
    <ThemeWrapper>
      <Suspense fallback={<Spinner fullScreen center size={6} />}>
        {appLoading ? <Spinner fullScreen center size={6} /> : children}
      </Suspense>
    </ThemeWrapper>
  );
}

AppInitializer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  initApp: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  getSPSubscriptionStatus: PropTypes.func.isRequired,
  getActiveProAccountsIds: PropTypes.func.isRequired,
  getDeviceFeatures: PropTypes.func.isRequired,
  getProAccount: PropTypes.func.isRequired,
  getCountries: PropTypes.func,
  getLatestAgreementsVersions: PropTypes.func.isRequired,
  getCloudStatus: PropTypes.func.isRequired,
  getAllBrands: PropTypes.func.isRequired,
  setUserDataState: PropTypes.func.isRequired,
  getAllLanguages: PropTypes.func.isRequired,
  getSupportedLanguages: PropTypes.func.isRequired,
  userLoggedIn: PropTypes.bool,
  userInfo: PropTypes.object,
  activeProAccounts: PropTypes.array,
  userDataState: PropTypes.string,
  servicePartner: PropTypes.object,
  selectedLanguage: PropTypes.string,
};

const actionProps = {
  initApp,
  getUserInfo,
  getSPSubscriptionStatus,
  getActiveProAccountsIds,
  getDeviceFeatures,
  getCountries,
  getLatestAgreementsVersions,
  getCloudStatus,
  getAllBrands,
  setUserDataState,
  getProAccount,
  getAllLanguages,
  getSupportedLanguages,
  selectSystem,
};

export default connect(
  ({ app, language: { selectedLanguage } }) => ({ ...app, selectedLanguage }),
  actionProps,
)(AppInitializer);
